export enum SearchResultType{
    UNKNOWN, 
    SWIMSPOT,
    EVENT
}